import styled from "styled-components";

export const TLLadyDesktop = styled.img`
    position: absolute;
    bottom: 18.9%;
    left: 23%;
    width: 46%;
    height: auto;
`;

export const TLCompassDesktop = styled.img`
    position: absolute;
    bottom: 53%;
    height: auto;
    left: 71%;
    width: 14%;
`;